"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _uniqid = _interopRequireDefault(require("uniqid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class ModalContent extends _react.Component {
  state = {
    id: (0, _uniqid.default)('modal-')
  };
  handleKeyDown = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (e.keyCode === 27) {
      return component.interceptClose(e);
    }
  };
  stopPropagation = e => {
    e.stopPropagation();
  };
  preventInteraction = e => {
    e.preventDefault();
    e.stopPropagation();
  };
  removeDocumentScroll = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const scroll_width = window.innerWidth - document.body.clientWidth;
    let scroll_area = props['scroll-area'] ? document.querySelector(props['scroll-area']) : document.body;
    if (!scroll_area) {
      console.error('bad scroll area submited to modal :', props['scroll-area']);
    }
    scroll_area.style.paddingRight = scroll_width + 'px';
    document.querySelector('html').classList.add('u-lock-scroll');
  };
  restoreDocumentScroll = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let scroll_area = props['scroll-area'] ? document.querySelector(props['scroll-area']) : document.body;
    if (!scroll_area) {
      console.error('bad scroll area submited to modal :', props['scroll-area']);
    }
    scroll_area.style.paddingRight = '';
    document.querySelector('html').classList.remove('u-lock-scroll');
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.removeDocumentScroll();
    document.getElementById(state.id).focus();
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.restoreDocumentScroll();
    if (props.src && props.src.focus instanceof Function) {
      props.src.focus();
    }
  }
  interceptClose = (e, label) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (component.busy === true) return;
    if (label === 'close') {
      if (props.onValidation) {
        props.onValidation();
      }
    } else if (props.onCancel) {
      props.onCancel();
    }
    component.busy = true;
    const modal = document.getElementById(state.id);
    modal.classList.add('c-modal-cover--fade');
    modal.lastChild.classList.add('c-modal--fade');
    window.setTimeout(function () {
      component.busy = undefined;
      props.onClose(e);
    }, 330);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const close_classes = props['close-classes'] === undefined ? 'c-btn c-btn--small' : props['close-classes'] || '';
    const footer_close_btn = props['with-footer-close'] !== false ? /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "aria-label": "Fermer",
      className: close_classes + ' c-modal__controls-close',
      onClick: e => component.interceptClose(e, 'close')
    }, props['close-label'] || 'Fermer') : undefined;
    let output = /*#__PURE__*/_react.default.createElement("aside", {
      className: ['c-modal-cover'].concat(props.bemit || []).join(' c-modal-cover--'),
      role: props.role || 'dialog',
      "aria-modal": "true",
      tabIndex: "-1",
      "aria-labelledby": props['aria-label'] || props.title,
      onKeyDown: component.handleKeyDown,
      onMouseDown: component.interceptClose,
      id: state.id
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: ['c-modal'].concat(props.bemit || []).join(' c-modal--'),
      onMouseDown: component.stopPropagation
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-modal__header",
      id: "modal-title"
    }, props.title ? /*#__PURE__*/_react.default.createElement("div", {
      className: "c-modal__title"
    }, props.title) : undefined), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-modal__body"
    }, props.children), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-modal__controls"
    }, props['action-buttons'], footer_close_btn), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "c-modal__close",
      onClick: component.interceptClose,
      ref: props['close-ref'],
      "aria-labelledby": "modal-close"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "u-hide-visually",
      id: "modal-close"
    }, "Fermer"), /*#__PURE__*/_react.default.createElement("svg", {
      className: "c-modal__close-icon",
      viewBox: "0 0 40 40"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M 10,10 L 30,30 M 30,10 L 10,30"
    })))));
    return output;
  }
}
exports.default = ModalContent;
